/**
 * Single source of truth for the 6 Finance sub-platform keys.
 * Keys MUST stay in sync with:
 *   • backend/routes/payment_methods.py   → VALID_PLATFORMS
 *   • backend/routes/payment_links.py     → PLATFORMS + CreateLinkIn.platform Literal
 *   • backend/routes/dropdown_lists.py    → VALID_PLATFORMS
 */
export const FINANCE_PLATFORM_META = {
  cloudgm_customers: { ar: 'CLOUDGM FZ LLC — منصة العملاء', en: 'CloudGM FZ LLC — Customers', color: '#1E9BD9' },
  cloudgm_merchants: { ar: 'CLOUDGM FZ LLC — منصة التجار', en: 'CloudGM FZ LLC — Merchants', color: '#8B5CF6' },
  // iter-261 (Feb 2026) — agents platform for agent-only invoices.
  // Records flow to the "Agent Invoice Payment Records" ledger.
  agents:            { ar: 'الوكلاء',                       en: 'Agents',                     color: '#eab308' },
  fitness:           { ar: '606 FITNESS',                  en: '606 FITNESS',                color: '#10b981' },
  cgm_coin:          { ar: 'CGM COIN',                     en: 'CGM COIN',                   color: '#d4af37' },
  community:         { ar: '606 COMMUNITY',                en: '606 COMMUNITY',              color: '#FF6B00' },
  mediadocs:         { ar: '606 MEDIADOCS',                en: '606 MEDIADOCS',              color: '#F5E6D3' },
};

export const FINANCE_PLATFORM_KEYS = Object.keys(FINANCE_PLATFORM_META);
